import { ApiService } from '@b2b/common/services/api/types';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

export const TemplatesCreateSchedulesControllerModule = angular
  .module('acme.view.application.templates.create.schedules.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.templates',
    'acme.common.service.themesHelper',
    'acme.view.application.templates.create.schedules.create.removeModal.controllers',
  ])
  .controller('TemplatesCreateSchedulesController', [
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'ApiService',
    'TemplatesService',
    'ThemesHelperService',
    function TemplatesCreateSchedulesController(
      $scope: IScope & { templatesCreateSchedules: TODO; templatesCreate: TODO },
      $state: StateService,
      $timeout: ITimeoutService,
      $uibModal: UIBModalService,
      ApiService: ApiService,
      TemplatesService: TODO,
      ThemesHelperService: ThemesHelperService
    ) {
      const ctrl = {
        model: [] as TODO[],
        privateModel: [] as TODO[],
        template: {} as TODO,
        mode: 'create',
        isLoaded: false,
        lastUpdated: false,
        lastPublished: false,
        admissionTypes: TemplatesService.admissionTypes,
        lastAdmissionType: '',
        toggleColumns: {
          duration: {
            field: 'duration',
            displayName: 'Duration',
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{ row.entity.duration  }} {{ row.entity.timesCount.standard }} <span class="sr-only" data-ng-if="row.entity.timesCount.standard > 1"> more start times</span></div>',
          },
          endTime: {
            field: 'endTime',
            displayName: 'End',
            cellTemplate:
              '<div class="ui-grid-cell-contents">{{ row.entity.endTime  }} {{ row.entity.timesCount.general }} <span class="sr-only" data-ng-if="row.entity.timesCount.general > 1">more end times</span></div>',
          },
        },
        emailSetting: 'always',
        company: ThemesHelperService.getCompany(),
        grid: {
          pageSize: 50,
          paginate: true,
          showFooter: true,
          enableRowSelection: false,
          multiselect: false,
          columns: [
            {
              field: 'edit',
              displayName: 'Edit',
              width: 50,
              onCellNavClick: (row, col) => {
                ctrl.gridDoubleClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
              visible: true,
              enableHiding: false,
              enableSorting: false,
            },
            {
              field: 'name',
              displayName: 'Name',
              sort: {
                direction: 'asc',
              },
            },
            {
              field: 'effectiveDates',
              displayName: 'Effective',
            },
            {
              field: 'repeatCycle',
              displayName: 'Occurs',
            },
            {
              field: 'startTime',
              displayName: 'Start',
              cellTemplate:
                '<div class="ui-grid-cell-contents">{{ row.entity.startTime  }} {{ row.entity.range }} <span class="sr-only" data-ng-if="row.entity.range > 1">more start times</span></div>',
            },
            {
              field: 'resourceRequestTypes',
              displayName: 'Resources',
            },
            {
              field: 'salesChannels',
              displayName: 'Channels',
            },
            {
              field: 'priceList',
              displayName: 'Price List',
            },
          ],
        },
        privateGrid: {
          pageSize: 1,
          paginate: false,
          showFooter: false,
          enableRowSelection: false,
          multiselect: false,
          columns: [
            {
              field: 'edit',
              displayName: 'Edit',
              width: 50,
              onCellNavClick: (row, col) => {
                ctrl.gridDoubleClick(row);
              },
              cellTemplate:
                '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
              visible: true,
              enableHiding: false,
              enableSorting: false,
            },
            {
              field: 'capacity',
              displayName: 'Capacity',
            },
            {
              field: 'duration',
              displayName: 'Duration',
              cellTemplate:
                '<div class="ui-grid-cell-contents">{{ row.entity.duration  }} {{ row.entity.timesCount.standard }} <span class="sr-only" data-ng-if="row.entity.timesCount.standard > 1"> more start times</span></div>',
            },
            {
              field: 'startTime',
              displayName: 'Start',
              cellTemplate:
                '<div class="ui-grid-cell-contents">{{ row.entity.startTime  }} {{ row.entity.range }} <span class="sr-only" data-ng-if="row.entity.range > 1">more start times</span></div>',
            },
            {
              field: 'resourceRequestTypes',
              displayName: 'Resources',
            },
            {
              field: 'priceList',
              displayName: 'Price List',
            },
          ],
        },

        init: function () {
          console.log('TemplatesCreateSchedulesController::init');
          if ($state.params && $state.params.id) {
            ctrl.mode = 'edit';
            // next tick
            $timeout(() => {
              ctrl.model = TemplatesService.getSchedulesList();
              ctrl.privateModel = TemplatesService.getPrivateSchedulesList();
              ctrl.isLoaded = true;
            }, 0);
          } else {
            ctrl.model = TemplatesService.getSchedulesList();
            ctrl.privateModel = TemplatesService.getPrivateSchedulesList();
            ctrl.isLoaded = true;
          }

          ctrl.template = TemplatesService.getModel();

          ctrl.spliceColumn(5, 0);

          ctrl.getNotificationPreference();

          TemplatesService.setIsTabLoading(false, 'schedules');

          $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
        },

        checkSave: function () {
          if (ctrl.template.admissionType !== ctrl.lastAdmissionType) {
            if (ctrl.isLoaded && !ctrl.hasSchedules()) {
              // TODO: APP-4332 - remove usage of parent controller
              // Save without publishing using the parent controller in $scope.templatesCreate
              $scope.templatesCreate.save({ publish: false, update: true });
            }
            ctrl.lastAdmissionType = ctrl.template.admissionType;
          }
          ctrl.manageColumnSwap();
        },

        manageColumnSwap: function () {
          if (ctrl.isGeneral()) {
            ctrl.replaceColumn('duration', ctrl.toggleColumns.endTime);
          } else if (ctrl.isStandard()) {
            ctrl.replaceColumn('endTime', ctrl.toggleColumns.duration);
          }
        },

        spliceColumn: function (start, end) {
          if (ctrl.isGeneral()) {
            ctrl.grid.columns.splice(start, end, ctrl.toggleColumns.endTime);
          } else if (ctrl.isStandard()) {
            ctrl.grid.columns.splice(start, end, ctrl.toggleColumns.duration);
          }
        },

        replaceColumn: function (field: string, replacement: TODO) {
          const idx = ctrl.grid.columns.findIndex((val) => val.field === field);
          ctrl.grid.columns[idx] = replacement;
        },

        hasSchedules: function () {
          return Array.isArray(ctrl.model) && ctrl.model.length;
        },

        hasPriceLists: function () {
          return TemplatesService.hasPriceLists();
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },

        onTemplatesServiceUpdate: function (e, data) {
          ctrl.model = TemplatesService.getSchedulesList();
          ctrl.privateModel = TemplatesService.getPrivateSchedulesList();
          ctrl.template = TemplatesService.getModel();
          ctrl.lastAdmissionType = ctrl.template.admissionType;

          ctrl.spliceColumn(5, 1);

          ctrl.isLoaded = true;
        },

        isStandard: function () {
          return ctrl.template.admissionType === 'standard';
        },

        isGeneral: function () {
          return ctrl.template.admissionType === 'generalAdmission';
        },

        gridDoubleClick: function (row) {
          $state.go('application.templates.edit.schedules.edit.times', { scheduleId: row.entity.id });
        },

        getNotificationPreference: function () {
          if (ctrl.company && ctrl.company.notificationPreference) {
            ctrl.emailSetting = ctrl.company.notificationPreference;
          }
        },

        removePrivateSchedule: function () {
          $uibModal
            .open({
              templateUrl: 'views/application/views/templates/create/schedules/modals/removeSchedule.tpl.html',
              size: 'md',
              controller: 'TemplatesCreateSchedulesRemoveModalController',
              resolve: {
                currentSchedule: () => ctrl.privateModel[0],
                SoldQuantity: () => ctrl.privateModel[0].soldQuantity,
                emailSetting: () => ctrl.emailSetting,
              },
            })
            .result.then(() => {
              ApiService.program.schedules
                .remove({
                  eventTemplateId: ctrl.template.id,
                  id: ctrl.privateModel[0].id,
                })
                .then(() => {
                  ctrl.privateModel = [];
                  TemplatesService.removePrivateSchedule();
                });
            });
        },
      };

      $scope.templatesCreateSchedules = ctrl;
      ctrl.init();
    },
  ]).name;
